import { use, useEffect, useRef, useState } from "react";
import { EyeOff, Eye, RefreshCcw, TurkishLira, CircleX } from "lucide-react";
import * as Toast from "@radix-ui/react-toast";
import {
  Loader2,
  TriangleAlert,
  CircleCheckBig,
  X,
  CheckCircle,
} from "lucide-react";
import { ClipLoader } from "react-spinners";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  ArcElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import {
  Box,
  Container,
  Stack,
  Typography,
  Select,
  MenuItem,
  FormControl,
  Autocomplete,
  TextField,
  OutlinedInput,
  Checkbox,
  ListItemText,
  InputLabel,
  Button,
  dividerClasses,
} from "@mui/material";
import * as Dialog from "@radix-ui/react-dialog";
import { GridLoader } from "react-spinners";
import * as Form from "@radix-ui/react-form";
import { handleLogin } from "./apiRoutes/login";

const query = new URLSearchParams(window.location.search);

const loginStatuses = {
  success: "success",
  failed: "failed",
};

export default function Login() {
  const [showPassword, setShowPassword] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [formData, setFormData] = useState({
    username: "",
    password: "",
    remember: false,
  });
  const [openToast, setOpenToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [loginStatus, setLoginStatus] = useState("");

  useEffect(() => {
    if (tmtLogin.is_login) {
      const roles = tmtLogin.user_roles;
      if (roles.includes("administrator")) {
        window.location.href = "event-metrics";
      } else if (roles.includes("event_volunteer")) {
        window.location.href = "attendance";
      } else if (roles.includes("subscriber")) {
        window.location.href = "subscriber-portal";
      }
    }
  }, []);

  const handleFormDataChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const login = async () => {
    setProcessing(true);
    try {
      const response = await handleLogin(formData);
      setToastMessage("Login Successful, Redirecting");
      await delay(3000);

      const roles = response.roles;

      if (roles.includes("administrator")) {
        window.location.href = "event-metrics";
      } else if (roles.includes("event_volunteer")) {
        window.location.href = "attendance";
      } else if (roles.includes("subscriber")) {
        window.location.href = "subscriber-portal";
      }

      setLoginStatus(loginStatuses.success);
    } catch (error) {
      setToastMessage("Invalid Username or Password");
      setLoginStatus(loginStatuses.failed);
    } finally {
      setOpenToast(true);
    }
    setProcessing(false);
  };

  function delay(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  return (
    <div className="walk-in-attendance-container">
      <Form.Root
        onSubmit={(e) => {
          e.preventDefault();
          login();
          // handleEventRegister();
          console.log("ay perpek!!💅💅💅");
        }}
        className="Root"
      >
        <Form.Field name="username" className="FormField">
          <Form.Label>Username</Form.Label>
          <Form.Control asChild className="FormControl">
            <input
              type="text"
              value={formData.username}
              name="username"
              onChange={handleFormDataChange}
              required
            />
          </Form.Control>
          <Form.Message match="valueMissing" className="FormError">
            Enter Username
          </Form.Message>
        </Form.Field>
        <Form.Field name="password" className="FormField">
          <Form.Label>Password</Form.Label>
          <div className="FormPasswordWrapper">
            <Form.Control asChild className="FormControl">
              <input
                type={showPassword ? "text" : "password"}
                value={formData.password}
                onChange={handleFormDataChange}
                required
              />
            </Form.Control>
            <Form.Message match="valueMissing" className="FormError">
              Enter Password
            </Form.Message>
            <div>
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                aria-label="Toggle password visibility"
                style={{
                  cursor: "pointer",
                  transition: "color 0.2s ease",
                }}
                onMouseEnter={(e) => (e.currentTarget.style.color = "#3b82f6")}
                onMouseLeave={(e) => (e.currentTarget.style.color = "black")}
              >
                {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
              </button>
            </div>
          </div>
        </Form.Field>
        <Form.Submit asChild>
          <button
            className={`ButtonW100 wpem-theme-button ${processing ? "disabled" : ""}`}
            type="submit"
            disabled={processing}
          >
            {processing ? "Logging In..." : "Log In"}
          </button>
        </Form.Submit>
      </Form.Root>
      <Dialog.Root open={processing}>
        <Dialog.Portal>
          <Dialog.Overlay
            className="loading-overlay"
            style={{
              position: "fixed",
              inset: 0,
              backgroundColor: "rgba(0, 0, 0, 0.4)",
              backdropFilter: "blur(3px)",
              zIndex: 9999,
            }}
          />
          <Dialog.Content
            className="loading-modal"
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              backgroundColor: "#fff",
              borderRadius: "12px",
              padding: "2rem 2.5rem",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "1rem",
              boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
              zIndex: 10000,
              textAlign: "center",
            }}
          >
            <GridLoader color="#2563eb" size={12} />
            <h3
              style={{
                fontWeight: 600,
                fontSize: "1.1rem",
                color: "#1e293b",
              }}
            >
              Logging In...
            </h3>
            <p style={{ fontSize: "0.9rem", color: "#475569" }}>
              Please wait a moment.
            </p>
          </Dialog.Content>
        </Dialog.Portal>
      </Dialog.Root>
      <Toast.Provider swipeDirection="right">
        <Toast.Root
          className={`toast-root ${
            loginStatus === loginStatuses.success
              ? "toast-success"
              : "toast-error"
          }`}
          open={openToast}
          onOpenChange={setOpenToast}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
            {loginStatus === loginStatuses.success ? (
              <CheckCircle size={20} />
            ) : (
              <CircleX size={20} />
            )}
            <Toast.Title style={{ fontWeight: 600 }}>
              {loginStatus === loginStatuses.success
                ? "Login Successful!"
                : "Login Failed"}
            </Toast.Title>
          </div>
          <Toast.Description style={{ fontSize: "0.9rem" }}>
            {loginStatus === loginStatuses.success
              ? "Redirecting"
              : toastMessage}
          </Toast.Description>
          <Toast.Close className="toast-close">✖</Toast.Close>
        </Toast.Root>

        <Toast.Viewport className="toast-viewport" />
      </Toast.Provider>
    </div>
  );
}
